import { useState } from "react";
import "./works.scss";

export default function Works() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const data = [
    {
      id: "1",
      icon: "./assets/iwalle-icon.png",
      title: "iWalle iOS App",
      desc:
        "iWalle generates wallpapers that you can use in your phone absolutely for free, and no ads. iWalle uses random math equations to generate absolutely astonishing and beautiful wallpapers.",
      img: "assets/iWalle.png"
        ,
      ref: "https://github.com/raguerraa/wally",
    },
    {
      id: "2",
      icon: "./assets/globe.png",
      title: "Naruto Sudoku iOS App",
      desc:
        "If you love Sudoku and you love Naruto then you will love this app. Naruto Sudoko is an iOS mobile app game where you have to solve Sudoku puzzles while your avatar is alive.",
      img:
      "assets/naruto-sudoku.png",
      ref: "https://github.com/raguerraa/ExtremestSudoku",
    },
    {
      id: "3",
      icon: "./assets/pixart-icon.png",
      title: "Pixart iOS App",
      desc:
        "Pixel Art is an iOS app that allows users to create pixelated artworks, save, edit and share them with friends.",
      img:
      "assets/pixart.png",
      ref: "https://github.com/chnchan/PixArt"
    },
  ];

  const handleClick = (way) => {
    way === "left"
      ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : 2)
      : setCurrentSlide(currentSlide < data.length - 1 ? currentSlide + 1 : 0);
  };
  
  return (
    <div className="works" id="works">
      <div
        className="slider"
        style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
      >
        {data.map((d) => (
          <div className="container">
            <div className="item">
              <div className="left">
                <div className="leftContainer">
                  <div className="imgContainer">
                    <img src={d.icon} alt="" />
                  </div>
                  <h2>{d.title}</h2>
                  <p>{d.desc}</p>
                  <span> <a href= {d.ref}>GitHub</a></span>
                </div>
              </div>
              <div className="right">
                <img
                  src={d.img}
                  alt=""
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <img
        src="assets/arrow.png"
        className="arrow left"
        alt=""
        onClick={() => handleClick("left")}
      />
      <img
        src="assets/arrow.png"
        className="arrow right"
        alt=""
        onClick={() => handleClick()}
      />
    </div>
  );
}
